var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKoreanLangIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "south-korea-flag-icon",
    transform: "translate(-9341 -13555)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8709",
    "data-name": "Rectangle 8709",
    width: 28,
    height: 20,
    transform: "translate(9341 13555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8709_-_Outline",
    "data-name": "Rectangle 8709 - Outline",
    d: "M.5.5v19h27V.5H.5M0,0H28V20H0Z",
    transform: "translate(9341 13555)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_00001",
    "data-name": 1,
    d: "M2.079,5.548,4.849,1.385l.692.463L2.771,6.009ZM1.036,4.855,3.812.693l.692.463L1.73,5.317ZM0,4.163,2.776,0l.693.463L.693,4.624Z",
    transform: "translate(9344.601 13556.91)",
    fill: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_00002",
    "data-name": 2,
    d: "M2.776,6.009h0L0,1.849l.693-.463L3.469,5.546l-.692.463Zm1.041-.692h0L2.545,3.41l.7-.462L4.511,4.854l-.694.463Zm1.037-.693h0L2.083.463,2.776,0,5.548,4.163l-.694.461Zm-2.54-1.56h0L1.041,1.156,1.736.693,3.009,2.6l-.694.462Z",
    transform: "translate(9344.597 13567.081)",
    fill: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_00003",
    "data-name": 3,
    d: "M2.776,6.009h0l-.692-.463L3.354,3.641l.693.462L2.777,6.009ZM1.736,5.317h0l-.694-.463L2.313,2.946l.694.463L1.736,5.317ZM.693,4.624h0L0,4.161,1.274,2.252l.693.462L.693,4.624Zm3.586-.867h0l-.692-.463L4.86,1.385l.692.463L4.279,3.757Zm-1.04-.694h0L2.545,2.6,3.817.693l.694.463L3.24,3.063ZM2.2,2.367h0L1.506,1.9,2.776,0l.693.463L2.2,2.367Z",
    transform: "translate(9359.852 13567.081)",
    fill: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_00004",
    "data-name": 4,
    d: "M2.776,6.009h0l-1.269-1.9L2.2,3.646l1.269,1.9-.692.461Zm1.041-.692h0L1.041,1.156,1.736.693,4.511,4.855l-.694.461Zm1.037-.693h0L3.582,2.717l.694-.461L5.547,4.163l-.692.461ZM1.276,3.76h0L0,1.849l.693-.463L1.969,3.3l-.693.461ZM3.352,2.371h0L2.079.463,2.771,0,4.044,1.91l-.692.461Z",
    transform: "translate(9359.852 13556.909)",
    fill: "#252422"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24213",
    "data-name": "Path 24213",
    d: "M19.087,12.082a5,5,0,1,1,1.385,6.932,5,5,0,0,1-1.385-6.932Z",
    transform: "translate(9331.751 13550.147)",
    fill: "#c62631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24214",
    "data-name": "Path 24214",
    d: "M19.087,14.13a2.5,2.5,0,1,0,4.161,2.776,2.5,2.5,0,1,1,4.161,2.776,5,5,0,0,1-8.323-5.552Z",
    transform: "translate(9331.75 13548.101)",
    fill: "#303c70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoreanLangIcon);
export default __webpack_public_path__ + "static/media/korean-lang-icon.12687c8866fc49331ae4309804d90ef8.svg";
export { ForwardRef as ReactComponent };